import type { FC } from "preact/compat";
import type { CheckboxProps } from "./interfaces";
import DoneIcon from "@material-design-icons/svg/outlined/done.svg";
import cn from "classnames";

const Checkbox: FC<CheckboxProps> = ({
    checked,
    onChange,
    className,
    label,
}) => (
    <label className={cn("flex items-center cursor-pointer group", className)}>
        <input
            type="checkbox"
            className="absolute w-0 h-0 opacity-0 peer"
            checked={checked}
            onClick={({ currentTarget }) => onChange?.(currentTarget.checked)}
        />
        <span
            className={cn(
                "w-5 h-5 mr-2 border border-gray-300 rounded-sm",
                "flex items-center justify-center",
                "transition-colors duration-200",
                "peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-sky-500 peer-focus:ring-offset-[2px] peer-focus:ring-offset-white-100",
                checked
                    ? "bg-sky-500 border-sky-500"
                    : "bg-white border-gray-300",
                checked
                    ? "group-hover:bg-sky-600 group-hover:border-sky-600"
                    : "group-hover:bg-gray-100 group-hover:border-gray-400"
            )}
        >
            <DoneIcon
                className={cn(
                    "transition duration-200",
                    checked && "fill-white",
                    checked ? "scale-1" : "scale-0 opacity-0"
                )}
                width="14"
                height="14"
            />
        </span>
        <span className="text-sm text-gray-600">{label}</span>
    </label>
);

export default Checkbox;
